import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Dropzone from 'react-dropzone'
import Form from './Form'

@inject(['websites'])
@observer
export default class GeneralSettings extends Component {
  state = {}

  handleData = data => {
    const { file } = this.state
    const formData = new FormData()
    for (const name in data) {
      formData.append(name, data[name])
    }
    if (file) {
      formData.append('logo', file)
    }
    const { signatureFile } = this.state
    if (signatureFile) {
      formData.append('signature_image', signatureFile)
    }

    return this.props.websites.save(formData)
  }

  handleFileDrop = files => {
    if (!files[0]) {
      alert('Invalid File! Please make sure you are uploading a proper image file no more than 512KB.')
    }
    this.setState({ file: files[0] })
  }

  handleSignatureFileDrop = files => {
    if (!files[0]) {
      alert('Invalid File! Please make sure you are uploading a proper image file no more than 512KB.')
    }
    this.setState({ signatureFile: files[0] })
  }

  getFilePreview(className) {
    const { file } = this.state
    let inner
    if (file) {
      inner = <div className="preview" style={{ backgroundImage: `url(${file.preview})` }} />
    } else {
      inner = <div className="status"/>
    }
    return (
      <div className={className}>{inner}</div>
    )
  }
  getSignatureFilePreview(className) {
    const { signatureFile } = this.state
    let inner
    if (signatureFile) {
      inner = <div className="preview" style={{ backgroundImage: `url(${signatureFile.preview})` }} />
    } else {
      inner = <div className="status"/>
    }
    return (
      <div className={className}>{inner}</div>
    )
  } 

  render() {
    const { current:website } = this.props.websites
    if (!website) return null

    return (
      <div className="container padded settings">
        <Form onData={this.handleData}>
          <div className="panel padded">
            <h2 className="title">General Settings</h2>
              <div className="form-section">
                <label>Logo</label>
                <p className="muted">Must be either a .jpg or .png file. This logo will be shown in the header of your email and used on your website.</p>
                <Dropzone
                  className="logo-dropzone"
                  multiple={false}
                  accept="image/*"
                  maxSize={512000}
                  onDrop={this.handleFileDrop}>
                  {({ isDragActive, isDragReject }) => {
                    if (isDragActive) {
                      return this.getFilePreview('active')
                    }
                    if (isDragReject) {
                      return this.getFilePreview('reject')
                    }
                    return this.getFilePreview('inactive')
                  }}
                </Dropzone>
                {website.logo && <div className="current-logo">
                  <h3>Current Logo</h3>
                  <img src={website.logo}/>
                </div>}
              </div>

              <div className="form-section">
                <label>Site Title</label>
                <p className="muted">This will be shown in various parts of your site. Your page titles for SEO are controlled separately.</p>
                <input name="name" defaultValue={website.name} />
              </div>

              <div className="form-section">
                <label>Display Phone Number</label>
                <p className="muted">This will be displayed on the Listing Detail Page. This can be different from the account owner’s phone number.</p>
                <input type="tel" name="display_phone" defaultValue={website.display_phone} />
              </div>

              <div className="form-section">
                <label>Display Email Address</label>
                <p className="muted">This will be displayed on the contact form. This can be different from the account owner’s email address.</p>
                <input type="email" name="display_email" defaultValue={website.display_email} />
              </div>

               <div className="form-section">
                <label>Signature</label>
                <p className="muted">Must be either a .jpg or .png file. This logo will be displayed in your email signature.</p>
                <Dropzone
                  className="logo-dropzone"
                  multiple={false}
                  accept="image/*"
                  maxSize={512000}
                  onDrop={this.handleSignatureFileDrop}>
                  {({ isDragActive, isDragReject }) => {
                    if (isDragActive) {
                      return this.getSignatureFilePreview('active')
                    }
                    if (isDragReject) {
                      return this.getSignatureFilePreview('reject')
                    }
                    return this.getSignatureFilePreview('inactive')
                  }}
                </Dropzone>
                {website.signature_image && <div className="current-logo">
                  <h3>Current Signature</h3>
                  <img src={website.signature_image}/>
                </div>}
              </div>
          </div>

          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/General.js